module.exports = __webpack_public_path__ + "assets/img/aprivate.2dbb3056.png";